import { DateTime } from "luxon";
import { TimeOnly } from "./timeOnly";
import { TimeZone } from "./timezones";

export function convertToTimeOnly(date: Date, timezone: TimeZone): TimeOnly {
	const dateTime: DateTime = DateTime.fromJSDate(date, { zone: timezone.identifier });

	return new TimeOnly(
		dateTime.hour,
		dateTime.minute,
		dateTime.second,
		dateTime.millisecond
	);
}

export function convertToDateTime(
	time: TimeOnly,
	timezone: TimeZone,
	date: Date = new Date()
): Date {
	return DateTime.fromJSDate(date, { zone: timezone.identifier })
		.set({
			hour: time.hour,
			minute: time.minute,
			second: time.second,
			millisecond: time.millisecond
		})
		.toJSDate();
}